<footer>
  <div class="bottom-footer">
    <div class="container">
      <div class="row">
        <!-- <div class="col-md-2 col-xs-12">
          <img src="/public/resources/images/footer logo@2x.png">
        </div> -->
        <div class="col-md-5 col-xs-12">
          <div class="static-pages">
            <ul>
              <li><a routerLink="/about-us">عن سبيرو</a></li>
              <li><a href="https://support.speero.net" target="_blank">الاسئله الشائعة</a></li>
              <li><a href="https://support.speero.net" target="_blank">مركز خدمة العملاء</a></li>
              <li><a routerLink="/payment-methods">طرق الدفع</a></li>
              <li><a href="https://speero.workable.com">انضم الى فريق العمل</a></li>
              <li><a routerLink="/contact-us">اتصل بنا</a></li>
            </ul>
          </div>
        </div>
        <div class="col-md-3 col-xs-12">
          <ul class="bottom-footer-list">
            <li>
              <a routerLink="/privacy-policy">سياسة الخصوصية</a>
            </li>
            <li>
              <a routerLink="/terms-and-conditions">الشروط والأحكام</a>
            </li>
          </ul>
        </div>
        <div class="col-md-2 col-xs-12">
          <div class="footer-social">
            <a href="#">
              <img src="/public/resources/images/twitter.png" />
            </a>
            <a href="#">
              <img src="/public/resources/images/instagram.png" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>
